// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	XmarkButton: 'xmark-button',
	AddButton: 'add-button',
	DeleteButton: 'delete-button',
	SaveButton: 'save-button',
	DateDatePicker: 'date-date-picker',
	DepositAmount: 'deposit-amount',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
